/*
 * Ficha técnica en imagen (JPG vertical) — Pro-Lighting
 * ---------------------------------------------------------------------------
 * Hermana del PDF. Misma fuente de datos (el metafield custom.ficha_tecnica),
 * pero pensada para el celular: formato vertical, letra grande, se lee sin
 * hacer zoom y se reenvía bien por WhatsApp.
 *
 * Por qué existe: en el celular la carpeta de descargas es un pozo. La galería
 * en cambio se mira todos los días. Una ficha que queda entre las fotos
 * vuelve a aparecer sola y recuerda quiénes somos.
 *
 * Cómo llega a la galería, que es el punto:
 *   · Android — la descarga normal cae en Descargas y la galería la indexa.
 *   · iPhone  — Safari manda TODA descarga a Archivos, sea JPG o PDF. La única
 *               vía real a Fotos es la hoja nativa de compartir, o que el
 *               usuario mantenga presionada la imagen. Por eso no descargamos
 *               a ciegas: mostramos la imagen y ofrecemos las dos acciones.
 *
 * No usa ninguna librería. Canvas 2D y nada más, así que la página de producto
 * no pesa un gramo extra. El ² del mm² acá sí se dibuja solo (canvas usa la
 * fuente del sistema), no hace falta el truco del PDF.
 */
(function (raiz) {
  'use strict';

  var AZUL = '#0A174B';
  var VERDE = '#119839';
  var VERDE_CLARO = '#78D696';
  var GRIS = '#6E7480';
  var GRIS_FILA = '#F3F5F8';
  var LINEA = '#D6DBE2';
  var TINTA = '#232832';

  var W = 1080;          // ancho fijo, alto según contenido
  var ALTO_MIN = 1350;   // vertical, pero sin regalar blanco al final
  var M = 60;            // margen lateral
  var FAM = '"Helvetica Neue", Helvetica, Arial, sans-serif';

  function f(peso, tam) { return peso + ' ' + tam + 'px ' + FAM; }

  function limpiar(s) {
    return String(s == null ? '' : s).replace(/ /g, ' ');
  }

  // Corta el texto en líneas que quepan en "ancho".
  function partir(ctx, txt, ancho) {
    var palabras = limpiar(txt).split(/\s+/);
    var lineas = [], actual = '';
    for (var i = 0; i < palabras.length; i++) {
      var prueba = actual ? actual + ' ' + palabras[i] : palabras[i];
      if (ctx.measureText(prueba).width > ancho && actual) {
        lineas.push(actual);
        actual = palabras[i];
      } else {
        actual = prueba;
      }
    }
    if (actual) lineas.push(actual);
    return lineas;
  }

  function garantiaDe(filas) {
    for (var i = 0; i < filas.length; i++) {
      if (String(filas[i][0]).toLowerCase().indexOf('garant') === 0) {
        return 'Garantía ' + limpiar(filas[i][1]);
      }
    }
    return '';
  }

  /*
   * Primero se mide todo con un canvas de juguete, después se crea el de
   * verdad con el alto justo. Así una ficha de 6 filas no sale con medio
   * metro de blanco abajo y una de 22 no se corta.
   */
  function medir(datos) {
    var c = document.createElement('canvas').getContext('2d');
    var filas = datos.ficha || [];
    var anchoTexto = W - M * 2;
    var colCampo = 400;

    c.font = f('bold', 48);
    var titulo = partir(c, datos.titulo, anchoTexto).slice(0, 3);

    var cuerpo = [];
    for (var i = 0; i < filas.length; i++) {
      c.font = f('bold', 30);
      var lc = partir(c, filas[i][0], colCampo - 24);
      c.font = f('normal', 30);
      var lv = partir(c, filas[i][1], anchoTexto - colCampo - 10);
      cuerpo.push({ campo: lc, valor: lv, alto: Math.max(lc.length, lv.length) * 40 + 30 });
    }
    return { titulo: titulo, cuerpo: cuerpo, colCampo: colCampo, anchoTexto: anchoTexto };
  }

  function dibujar(datos, img) {
    var plan = medir(datos);
    var hayFoto = !!img;

    /*
     * La foto cede espacio cuando la tabla es larga. Sin esto una ficha de 22
     * filas sale de tres metros de alto: en la galería del teléfono se ve como
     * una tira y hay que hacer zoom para leer. Achicando la foto la hoja queda
     * en una proporción que se lee de un vistazo.
     */
    var n = plan.cuerpo.length;
    var fotoLado = n <= 10 ? 620 : (n <= 16 ? 480 : 400);

    var y = 236;                                   // bajo la cabecera
    if (hayFoto) y += fotoLado + 40;
    y += plan.titulo.length * 58 + 14;             // título
    y += 46;                                       // código · marca
    y += 78;                                       // rótulo "Ficha técnica"
    for (var i = 0; i < plan.cuerpo.length; i++) y += plan.cuerpo[i].alto;
    y += 40;

    var altoPie = 170;
    var alto = Math.max(ALTO_MIN, y + altoPie);

    var cv = document.createElement('canvas');
    cv.width = W;
    cv.height = alto;
    var c = cv.getContext('2d');

    c.fillStyle = '#FFFFFF';
    c.fillRect(0, 0, W, alto);

    // ---- cabecera
    c.fillStyle = AZUL;
    c.fillRect(0, 0, W, 156);
    c.fillStyle = VERDE;
    c.fillRect(0, 156, W, 10);

    c.textBaseline = 'alphabetic';
    c.font = f('bold', 62);
    c.fillStyle = '#FFFFFF';
    c.fillText('PRO', M, 92);
    var wPro = c.measureText('PRO').width;
    c.fillStyle = VERDE_CLARO;
    c.fillText('LIGHTING', M + wPro + 12, 92);

    c.font = f('normal', 20);
    c.fillStyle = '#C4CCDE';
    c.fillText('I L U M I N A C I Ó N', M + 2, 126);

    c.font = f('bold', 26);
    c.fillStyle = '#FFFFFF';
    c.textAlign = 'right';
    c.fillText('FICHA TÉCNICA', W - M, 100);
    c.textAlign = 'left';

    var cy = 236;

    // ---- foto
    if (hayFoto) {
      var fx = (W - fotoLado) / 2;
      c.strokeStyle = LINEA;
      c.lineWidth = 2;
      c.strokeRect(fx, cy, fotoLado, fotoLado);
      // encuadre sin deformar: se recorta el lado largo
      var lado = Math.min(img.width, img.height);
      var sx = (img.width - lado) / 2, sy = (img.height - lado) / 2;
      c.drawImage(img, sx, sy, lado, lado, fx + 6, cy + 6, fotoLado - 12, fotoLado - 12);
      cy += fotoLado + 40;
    }

    // ---- título
    c.font = f('bold', 48);
    c.fillStyle = AZUL;
    for (var t = 0; t < plan.titulo.length; t++) {
      c.fillText(plan.titulo[t], M, cy + 44);
      cy += 58;
    }
    cy += 14;

    // ---- código · marca
    var meta = [];
    if (datos.sku) meta.push('Código ' + limpiar(datos.sku));
    if (datos.vendor) meta.push(limpiar(datos.vendor));
    c.font = f('normal', 30);
    c.fillStyle = GRIS;
    if (meta.length) c.fillText(meta.join('   ·   '), M, cy + 26);
    cy += 46;

    // ---- rótulo de la tabla
    c.font = f('bold', 36);
    c.fillStyle = AZUL;
    c.fillText('Ficha técnica', M, cy + 46);
    c.fillStyle = VERDE;
    c.fillRect(M, cy + 60, 110, 5);
    cy += 78;

    // ---- filas
    for (var r = 0; r < plan.cuerpo.length; r++) {
      var fila = plan.cuerpo[r];
      if (r % 2 === 0) {
        c.fillStyle = GRIS_FILA;
        c.fillRect(M, cy, plan.anchoTexto, fila.alto);
      }
      c.font = f('bold', 30);
      c.fillStyle = AZUL;
      for (var a = 0; a < fila.campo.length; a++) {
        c.fillText(fila.campo[a], M + 16, cy + 15 + 40 * (a + 1) - 11);
      }
      c.font = f('normal', 30);
      c.fillStyle = TINTA;
      for (var b = 0; b < fila.valor.length; b++) {
        c.fillText(fila.valor[b], M + plan.colCampo, cy + 15 + 40 * (b + 1) - 11);
      }
      cy += fila.alto;
    }

    // ---- pie, pegado abajo
    var py = alto - altoPie;
    c.fillStyle = AZUL;
    c.fillRect(0, py, W, altoPie);
    c.fillStyle = VERDE;
    c.fillRect(0, py, W, 8);

    var gar = garantiaDe(datos.ficha || []);
    c.font = f('bold', 34);
    c.fillStyle = '#FFFFFF';
    if (gar) c.fillText(gar, M, py + 70);

    c.font = f('normal', 26);
    c.fillStyle = '#C4CCDE';
    c.fillText('ventas@proaraser.cl   ·   proaraser.cl', M, py + 116);
    c.font = f('normal', 22);
    c.textAlign = 'right';
    c.fillText('Pro Araser SpA   ·   Despacho a todo Chile', W - M, py + 116);
    c.textAlign = 'left';

    return cv;
  }

  function nombreArchivo(datos) {
    var base = limpiar(datos.sku || datos.titulo || 'ficha').toLowerCase();
    if (base.normalize) base = base.normalize('NFD').replace(/[̀-ͯ]/g, '');
    base = base.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return 'ficha-' + (base || 'producto') + '.jpg';
  }

  raiz.FichaImagenProLighting = { dibujar: dibujar, nombreArchivo: nombreArchivo };

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function cargarImagen(url) {
    return fetch(url, { mode: 'cors' })
      .then(function (r) { if (!r.ok) throw new Error('img'); return r.blob(); })
      .then(function (b) {
        return new Promise(function (ok, mal) {
          var fr = new FileReader();
          fr.onload = function () {
            var im = new Image();
            im.onload = function () { ok(im); };
            im.onerror = mal;
            im.src = fr.result;      // dataURL: el canvas no queda contaminado
          };
          fr.onerror = mal;
          fr.readAsDataURL(b);
        });
      });
  }

  /*
   * La vista previa no es adorno. En iPhone es la única forma segura de que
   * la imagen llegue a Fotos: o la hoja de compartir (que exige un gesto
   * fresco del usuario, por eso el botón va acá dentro y no en la página) o
   * mantener presionada la imagen.
   */
  function mostrar(blob, nombre, titulo) {
    var url = URL.createObjectURL(blob);
    var capa = document.createElement('div');
    capa.className = 'ficha-img-capa';
    capa.innerHTML =
      '<div class="ficha-img-caja">' +
        '<img class="ficha-img-foto" alt="' + String(titulo || '').replace(/"/g, '&quot;') + '">' +
        '<p class="ficha-img-pista">Mantén presionada la imagen para guardarla en tus fotos.</p>' +
        '<div class="ficha-img-acciones">' +
          '<button type="button" class="ficha-img-btn ficha-img-btn--si" data-compartir hidden>Guardar en el teléfono</button>' +
          '<a class="ficha-img-btn" data-bajar download>Descargar</a>' +
          '<button type="button" class="ficha-img-btn ficha-img-btn--no" data-cerrar>Cerrar</button>' +
        '</div>' +
      '</div>';

    capa.querySelector('.ficha-img-foto').src = url;
    var bajar = capa.querySelector('[data-bajar]');
    bajar.href = url;
    bajar.download = nombre;

    var archivo = null;
    try { archivo = new File([blob], nombre, { type: 'image/jpeg' }); } catch (e) { archivo = null; }
    var compartir = capa.querySelector('[data-compartir]');
    if (archivo && navigator.canShare && navigator.canShare({ files: [archivo] })) {
      compartir.hidden = false;
      compartir.addEventListener('click', function () {
        navigator.share({ files: [archivo], title: titulo || 'Ficha técnica' })
          .catch(function () { /* si cancela, no pasa nada */ });
      });
    }

    function cerrar() {
      URL.revokeObjectURL(url);
      capa.remove();
      document.removeEventListener('keydown', tecla);
    }
    function tecla(ev) { if (ev.key === 'Escape') cerrar(); }

    capa.querySelector('[data-cerrar]').addEventListener('click', cerrar);
    capa.addEventListener('click', function (ev) { if (ev.target === capa) cerrar(); });
    document.addEventListener('keydown', tecla);
    document.body.appendChild(capa);
  }

  function manejar(boton) {
    var caja = boton.closest('[data-ficha-pdf-raiz]');
    if (!caja) return;
    var nodo = caja.querySelector('[data-ficha-pdf-datos]');
    if (!nodo) return;
    var datos;
    try { datos = JSON.parse(nodo.textContent); } catch (e) { return; }

    var original = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Generando…';

    var restaurar = function () { boton.textContent = original; boton.disabled = false; };

    (datos.imagen ? cargarImagen(datos.imagen).catch(function () { return null; })
                  : Promise.resolve(null))
      .then(function (img) {
        var cv = dibujar(datos, img);
        cv.toBlob(function (blob) {
          if (!blob) { restaurar(); return; }
          mostrar(blob, nombreArchivo(datos), datos.titulo);
          restaurar();
        }, 'image/jpeg', 0.92);
      })
      .catch(function () {
        boton.textContent = 'No se pudo generar';
        setTimeout(restaurar, 2600);
      });
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('[data-ficha-imagen]') : null;
    if (!b) return;
    ev.preventDefault();
    manejar(b);
  });
})(typeof module !== 'undefined' && module.exports ? module.exports : window);
